/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import withValidarPago from 'HOC/withValidarPago';
import { consumirServicioEncirptacion } from 'api';
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import Page from 'components/Page';
import { ALBERT_EVENTS } from 'constants/albert_events';
import { ambienteAplicacion, urlDonwloadVoucher, urlPago } from 'constants/urls';
import { URLS_PHP_7 } from 'constants/urls_v2';
import { useAccionesPantallaPago, usePantallaPago } from 'contexts/FormPagoContext';
import useAlbert from 'hooks/useAlbert';
import useCustomLocation from 'hooks/useCustomLocation';
import useCustomRouter from 'hooks/useCustomRouter';
import useCustomToast from 'hooks/useCustomToasts';
import useQueryParams from 'hooks/useQueryParams';
import useUsuario from 'hooks/useUsuario';
import React, { useCallback, useEffect, useRef } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import { getQueryParams, mappRutasEmision, timeout } from 'utils/funciones';
import Loading from 'wrappers/Loading';
import BottomButtons from './components/BottomButtons';
import BottomButtonsPagoRealizado from './components/BottomButtonsPagoRealizado';
import BreadCrumbPago from './components/BreadCrumbPago';
import Container from './components/Container';
import DetallePagoRealizado from './components/DetallePagoRealizado';
import Encuesta from './components/Encuesta';
import FormPago from './components/FormPago';
import FormPagoOnlyTarjeta from './components/FormPagoOnlyTarjeta';
import { MEDIOS_PAGO, SUB_MEDIOS_PAGO, SUB_MEDIOS_PAGO_KEYS } from './constants';
import { PagoException, ValidacionContinuarPagoException } from './exceptions';
import { URLS_PAGO } from './urls';

const API = ApiKeyFetch.instance();

const getMsgCorreoCobro = (correo) => {
  return `Hemos enviado un correo de solicitud de cobro a la dirección ${correo} correctamente`;
};

const PagoPage = ({ estadoGeneral }) => {
  const { idPoliza, codProducto, ingreso } = useQueryParams();

  const history = useCustomRouter();

  const { addWarningToast, addSuccessToast } = useCustomToast();

  const location = useCustomLocation();

  const methods = useForm({
    mode: 'onChange',
    defaultValues: {
      // medioPago: {
      //   label: 'Pago Suscripción',
      //   value: 'suscripcion',
      // },
      // subMedio: {
      //   label: 'Ingresar tarjeta',
      //   value: 'tarjeta',
      // },
      // tarjetaSeleccionada: {
      //   typeName: 'visa',
      //   mask: '9999-9999-9999-9999',
      //   placeholder: '9999-9999-9999-9999',
      //   length: 16,
      // },
      // numTarjeta: '2352345234523452',
      // cvv: '123',
      // titular: 'dsafasdfasdf',
      // expiracion: '12/2025',
    },
  });

  const { dataUsuario } = useSelector((state) => state.datosUsuarios);

  const usuario = useUsuario();

  const { addAutoEvent, AUTO_EVENTS, AUTO_OPERATIONS, addApEvent } = useAlbert();

  const statePantalla = usePantallaPago();
  const { datosTarifacion, catalogo, loading, isPagoRealizado } = statePantalla;
  const accionesPantalla = useAccionesPantallaPago();
  const { setLoading } = accionesPantalla;

  const redirectToComplete = () => {
    const qParams = getQueryParams();
    if (!qParams?.completed) {
      const url = `${location.fullPathname}&completed=true`;
      history.replace(url);
    }
  };

  const init = async () => {
    setLoading(true);

    const promiseMediosPago = API.post(URLS_PAGO.mediosPago, {
      idPoliza,
      codProducto,
      idUsuario: usuario?.cliCodigoCore || null,
      isFromLinkCobro: statePantalla.isFromLinkCobro,
    });

    const promiseCatalogos = API.post(URLS_PAGO.catalogoPantalla, {
      ambiente: ambienteAplicacion,
      pasoPago: 'obtenerRedireccionamiento',
      polCodigo: idPoliza,
      usuCodigo: dataUsuario.cliCodigoCore,
      prodCodigo: codProducto,
      pasoEmision: 'listarTotales',
    });

    const [responseMedios, responseCatalogo] = await Promise.all([promiseMediosPago, promiseCatalogos]);

    console.log('MEDIOS: ', responseMedios);
    console.log('CATALOGO: ', responseCatalogo);

    if (responseMedios?.data?.formData) {
      methods.reset(responseMedios?.data?.formData);
    }

    accionesPantalla.setState({
      catalogo: {
        ...responseCatalogo.data.catalogo,
        ...responseCatalogo.data.pago,
      },
      showOnlyFormPago: usuario.isDTC,
      newRoutes:
        responseCatalogo?.data?.pago?.pasosRedireccionamiento &&
        mappRutasEmision(responseCatalogo?.data?.pago?.pasosRedireccionamiento || []),
      mediosPago: responseMedios?.data?.medios?.map((item) => ({ ...item, value: item })),
      subMedios: responseMedios?.data?.subMedios?.map((item) => ({ ...item, value: item })),
      datosTarifacion: responseCatalogo.data.catalogo.polValoresTotales,
      isPagoRealizado: responseMedios.data.polizaPagada,
      medioPagoUsado: responseMedios.data.medioPagoSeleccionado,
      polizaCompletada: responseMedios.data.polizaCompletada,
      numeroPoliza: responseMedios.data.numeroPoliza,
      detallePago: responseCatalogo?.data?.pago?.objDetallePago,
    });

    setLoading(false);
  };

  useEffect(() => {
    init();
  }, []);

  const generatePDF = async () => {
    if (codProducto !== PRODUCTOS.HOGAR_FLEX) return null;
    const { data } = await ApiKeyFetch.instance().post(URLS_PHP_7.hogarCommon.descargarPdfGo4It, {
      idPoliza,
      codProducto,
    });
    const { url: urlPDF } = data || {};
    return urlPDF || null;
  };

  const addAlbertEvent = async () => {
    const primaNeta = String(catalogo?.polValoresTotales?.primaTotal || '').replace(',', '');
    const payload = {
      albert_transaction_id: idPoliza,
      albert_value: primaNeta,
    };
    if (codProducto === PRODUCTOS.AUTO) {
      // Agregando evento Albert ----------------------------
      addAutoEvent(AUTO_OPERATIONS.albert_dtc_auto, AUTO_EVENTS.albert_purchase, payload);
      // Fin Agregando evento Albert ----------------------------
    }

    if (codProducto === PRODUCTOS.APINDIVIDUAL) {
      addApEvent(ALBERT_EVENTS.PURCHASE, payload);
    }
  };

  const donwload = async () => {
    const body = {
      empresa: 'AIGMEX',
      plataforma: 'WEB',
      idPoliza: idPoliza,
    };

    await ApiKeyFetch.instance().post(urlDonwloadVoucher, body);
  };

  const encuestaRef = useRef(null);

  useEffect(() => {
    if (isPagoRealizado) {
      redirectToComplete();
    }
  }, [isPagoRealizado]);

  const enviarCorreoPago = useCallback(async (data) => {
    const Data = {
      datosPago: {
        ambiente: ambienteAplicacion,
        cotPasoCodigo: 'enviarCorreoPago',
        polCodigo: idPoliza,
        codProducto,
        email: data.correo,
        url: window.location.href,
        formData: {
          ...data,
          subMedio: SUB_MEDIOS_PAGO_KEYS.tarjeta,
        },
      },
    };

    const DataSaltarPago = {
      datosPago: {
        ambiente: ambienteAplicacion,
        cotPasoCodigo: 'saltarTarjetaBroker',
        polCodigo: idPoliza,
      },
    };

    const [res, resSaltar] = await Promise.all([
      API.post(URLS_PHP_7.emision.pago, Data),
      API.post(URLS_PHP_7.emision.pago, DataSaltarPago),
    ]);
    console.log("Mensaje del pago" + res);
    if (res?.transaccion === true && res?.permitirEmitir === false) {
      addWarningToast(res?.msgError);
      return;
    }
    console.log("Mensaje del pago 2" + res);
    if (res.transaccion && resSaltar.transaccion) {
      addSuccessToast(getMsgCorreoCobro(data.correo));
      accionesPantalla.setState({
        showFormPago: false,
        showFormCancelarTokens: true,
        enviandoLinkCobro: false,
      });
    } else {
      addWarningToast('Ha ocurrido un problema al enviar el correo, por favor intente nuevamente');
    }
  }, []);

  const pagarFormaTradicional = async (data) => {
    console.log('PAGO TRADICIONAL');
    const Data = {
      datosPago: {
        ambiente: ambienteAplicacion,
        cotPasoCodigo: 'pagoTradicional',
        polCodigo: idPoliza,
        isFromLinkCobro: statePantalla.isFromLinkCobro,
      },
    };

    console.log('PAGO TRADICIONAL');

    const res = await consumirServicioEncirptacion(urlPago, Data);
    console.log('RESPONSE PAGO TRADICIONAL: ', res);

    if (res?.transaccion === true && res?.permitirEmitir === false) {
      console.log('RESPONSE PAGO TRADICIONAL 2: ', res);
      addWarningToast(res?.msgError);
      return true;
    }

    if (res?.transaccion === false && res?.errorType === 'validacion-continuar-pago') {
      throw new ValidacionContinuarPagoException(res?.message);
    }

    if (res?.transaccion === true && res?.errorCodigo === 0 && res?.pago?.data) {
      redirectToComplete();
      await Promise.all([addAlbertEvent(), generatePDF(), donwload()]);
      return true;
    }

    throw new PagoException(
      res?.pago?.errorDescription ||
      res?.pago?.errorDescripcion ||
      res?.errorDescripcion ||
      'Ha ocurrido un problema al momento de procesar tu información'
    );
  };

  const fetchCargoRecurrente = async (data) => {
    if (!statePantalla.isTarjetaValida) {
      throw new PagoException('Se debe validar la tarjeta para poder continuar con el proceso');
    }
    data.mesExpiracion = data.expiracion.split('/')[0];
    data.anioExpiracion = data.expiracion.split('/')[1];

    const Data = {
      datosPago: {
        ambiente: ambienteAplicacion,
        cotPasoCodigo: 'cargoRecurrente',
        polCodigo: idPoliza,
        ...data,
        idPlazo: datosTarifacion.idPlazo,
        formaPago: datosTarifacion.formaPago,
        realizarPago: data?.medioPago?.value === MEDIOS_PAGO.pago,
        isFromLinkCobro: statePantalla.isFromLinkCobro,
      },
    };
    const res = await consumirServicioEncirptacion(urlPago, Data);
    console.log('RES CARGO RECURRENTE: ', res);

    if (res?.transaccion === false) {
      if (res?.errorType === 'validacion-continuar-pago') {
        throw new ValidacionContinuarPagoException(res?.message);
      }
      if (res?.msgError) {
        throw new PagoException(res?.msgError);
      }
    }
    return res;
  };

  const pagarFormaOnline = async (data) => {
    console.log('PAGO ONLINE');
    const res = await fetchCargoRecurrente(data);
    if (res?.transaccion === true && res?.permitirEmitir === false) {
      addWarningToast(res?.msgError);
      return true;
    }

    if (
      res?.transaccion === true &&
      res?.pago?.isValid === true &&
      String(res?.pago?.detallePago?.ResultType) === '1'
    ) {
      addSuccessToast(
        `Se envió un correo electrónico a ${statePantalla?.catalogo?.emailContratante} con la información del pago`
      );
      redirectToComplete();
      await Promise.all([addAlbertEvent(), generatePDF(), donwload()]);
      return true;
    }

    throw new PagoException(
      res?.pago?.errorDescripcion ||
      res?.errorDescripcion ||
      'Ha ocurrido un problema al momento de procesar tu información'
    );
  };

  const pagarFormaSuscripcion = async (data) => {
    const res = await fetchCargoRecurrente(data);
    if (res?.transaccion === true && res?.permitirEmitir === false) {
      addWarningToast(res?.msgError);
      return true;
    }

    if(res.transaccion === true && res.pago.isValid === true)
    {
      return true;
    }

    throw new PagoException(
      res?.pago?.errorDescripcion ||
      res?.errorDescripcion ||
      'Ha ocurrido un problema al momento de procesar tu información'
    );

  };

  const pagar = async (data) => {
    const medioPago = data?.medioPago?.value;
    const subMedio = data?.subMedio?.value;
    if (medioPago === MEDIOS_PAGO.pagoTradicional) {
      await pagarFormaTradicional(data);
    }

    if (medioPago === MEDIOS_PAGO.pago && subMedio === SUB_MEDIOS_PAGO.tarjeta) {
      await pagarFormaOnline(data);
    }
    if (medioPago === MEDIOS_PAGO.suscripcion && subMedio === SUB_MEDIOS_PAGO.tarjeta) {
      await pagarFormaSuscripcion(data);
    }

    await init();
    encuestaRef.current.loadEncuesta();
  };

  const onSubmitForm = async (data) => {
    console.log('ON SUBMIT: ', data);
    accionesPantalla.setLoadingForm(true);
    try {
      const medioPago = data?.medioPago?.value;
      const subMedio = data?.subMedio?.value;

      if (subMedio === SUB_MEDIOS_PAGO.correo && statePantalla.isFromLinkCobro === false) {
        await enviarCorreoPago(data);
      }

      if (
        [MEDIOS_PAGO.pago, MEDIOS_PAGO.suscripcion, MEDIOS_PAGO.pagoTradicional].includes(medioPago) &&
        (subMedio !== SUB_MEDIOS_PAGO.correo || statePantalla.isFromLinkCobro === true)
      ) {
        await pagar(data);
      }
    } catch (error) {
      console.log('ERROR: ', error);
      if (error instanceof PagoException) {
        addWarningToast(error.message);
      } else if (error instanceof ValidacionContinuarPagoException) {
        addWarningToast(error.message);
        await timeout(1000);
        window.location.reload();
      } else {
        addWarningToast(`Ha ocurrido un error inesperado: ${error.message}`);
      }
    }
    accionesPantalla.setLoadingForm(false);
  };

  const onSubmitFormError = () => {
    addWarningToast('Para continuar debes llenar toda la información solicitada');
  };

  const productoActivoEnDtc = (codProducto, isDtc) => {
    const arrayProductos = [
      PRODUCTOS.AUTO,
      PRODUCTOS.HOGAR,
      PRODUCTOS.HOGAR_DTC,
      PRODUCTOS.HOGAR_FLEX,
      PRODUCTOS.SEGUKIDS,
      PRODUCTOS.TRAVELBTA,
      PRODUCTOS.APINDIVIDUAL,
      PRODUCTOS.lnPresRcpa
    ];
    if (isDtc === false) {
      return true;
    }
    if (arrayProductos.includes(codProducto) && isDtc === true) {
      return true;
    }
  };

  return (
    <FormProvider {...methods}>
      <Loading loading={loading}>
        <Encuesta ref={encuestaRef} />
        <Page>
          {productoActivoEnDtc(codProducto, statePantalla.showOnlyFormPago) &&
            <BreadCrumbPago
              codProducto={codProducto}
              newRoutes={statePantalla.newRoutes}
              isPagoRealizado={isPagoRealizado}
            />}
          {productoActivoEnDtc(codProducto, statePantalla.showOnlyFormPago) && <Container>
            {!isPagoRealizado && !statePantalla.showOnlyFormPago && <FormPago codProducto={codProducto} />}
            {!isPagoRealizado && statePantalla.showOnlyFormPago && <FormPagoOnlyTarjeta />}
            {isPagoRealizado && <DetallePagoRealizado />}

            {!isPagoRealizado && <BottomButtons onSubmit={onSubmitForm} onSubmitFormError={onSubmitFormError} />}

            {isPagoRealizado && <BottomButtonsPagoRealizado />}
          </Container>}
        </Page>
      </Loading>
    </FormProvider>
  );
};

// export default withValidarPago(withValidarRecuperar(PagoPage));
export default withValidarPago(PagoPage);
